<template>
  <div
    v-if="showLoadingState < 1"
    key="loading state"
  >
    <AtomLoadingSecondary/>
  </div>

  <div
    v-else
    class="m-edition-billing-my-payments-change-plan"
  >
    <div class="m-edition-billing-my-payments-change-plan-frecuency">
      <p class="a-input-side">
        <label class="a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary">
          <input
            v-model="frecuencySelected"
            name="frecuencia"
            type="radio"
            value="mensual"
          >
          <span class="a-radiobutton-checkmark"></span>
          Mensual
        </label>
      </p>
      <p>
        <label class="a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary">
          <input
            v-model="frecuencySelected"
            name="frecuencia"
            type="radio"
            value="anual"
          >
          <span class="a-radiobutton-checkmark"></span>
          Anual
        </label>
      </p>
    </div>

    <div class="m-edition-billing-my-payments-change-plan-frecuency">
      <p
        v-for="(divisa, index) in divisaByGestion"
        :key="index"
        class="a-input-side"
      >
        <label class="a-radiobutton-primary a-radiobutton-margin-right-large a-radiobutton-billing-primary">
          <input
            v-model="divisaSelected"
            name="divisa"
            type="radio"
            :value="divisa.iso_code"
          >
          <span class="a-radiobutton-checkmark"></span>
          {{ divisa.nombre }}
        </label>
      </p>
    </div>

    <div
      v-if="showLoadingStateProduct < cantPV"
      key="loading state"
    >
      <AtomLoadingSecondary/>
    </div>

    <div v-else>
      <div class="m-edition-billing-my-payments-change-plan-list">
        <article
          v-for="(producto, index) in mostrarProductosVidroop"
          v-show="((producto.pago && frecuencySelected === 'anual' && producto.planAnual) || (producto.pago && frecuencySelected === 'mensual' && producto.planMensual)) || (!producto.pago && (!producto.planMensual && !producto.planAnual))"
          :key="index"
          class="m-card-primary m-card-transition m-edition-billing-my-payments-change-plan-list-element"
        >
          <span :class="`plan-list-element-circle plan-list-element-circle-${producto.class}`"></span>
          <h2 class="plan-list-element-name">{{ producto.nombre }}</h2>
          <span v-if="producto.pago">
            <h3
              v-if="frecuencySelected === 'anual'"
              :class="`plan-list-element-price plan-list-element-price-${producto.class}`"
            >
              <span v-if="producto.planAnual">
                <span>
                  {{ producto.divisa.simbolo }}
                </span>
                {{ producto.planAnual.pago.precio }}
              </span>
            </h3>
            <h3
              v-if="frecuencySelected === 'mensual'"
              :class="`plan-list-element-price plan-list-element-price-${producto.class}`"
            >
              <span v-if="producto.planMensual">
                <span>
                  {{ producto.divisa.simbolo }}
                </span>
                {{ producto.planMensual.pago.precio }}
              </span>
            </h3>
          </span>
          <span v-else>
            <h3 :class="`plan-list-element-price plan-list-element-price-${producto.class}`">
              <span>
                Gratis
              </span>
            </h3>
          </span>
          <span
            v-if="!producto.planMensual && !producto.planAnual"
            class="plan-list-element-price-frecuency"
          >
            (Toda la vida)
          </span>
          <span
            v-else-if="frecuencySelected === 'anual'"
            class="plan-list-element-price-frecuency"
          >
            (Al año)
          </span>
          <span
            v-else
            class="plan-list-element-price-frecuency"
          >
            (Al mes)
          </span>
          <ul class="plan-list-element-features">
            <li><span>{{ producto.maximo_administradores }}</span> Administradores</li>
            <li><span>{{ producto.maximo_profesores }}</span> Profesores</li>
            <li><span>{{ producto.maximo_instructores }}</span> Instructores</li>
            <li><span>{{ producto.maximo_alumnos }}</span> Alumnos</li>
            <li><span>Ilimitado</span> Proyectos</li>
            <li><span>Ilimitado</span> Mapas de Aprendizaje</li>
            <li><span>Ilimitado</span> Productos</li>
            <li><span>Ilimitado</span> Puntos de Venta</li>
            <li><span>{{ producto.maximo_emails }}</span> Listas de e-mail</li>
            <li><span>{{ producto.universidad }}</span> Universidad</li>
            <li v-if="false"><span>{{ producto.comisiones }}</span>% Comisiones</li>
            <li v-show="producto.integraciones">Integraciones</li>
            <li v-show="producto.clases_vivo && false">Clases en vivo por Zoom</li>
            <li v-show="producto.afiliaciones && false">Afiliaciones</li>
            <li v-show="producto.evaluaciones && false">Evaluaciones</li>
            <li v-show="producto.control_alumnos && false">Control de alumnos</li>
            <li v-show="producto.importacion_alumnos && false">Importación de alumnos</li>
          </ul>
          <a
            v-if="venta.venta.producto_venta === producto.id && frecuencySelected === frecuencyOriginal"
            :class="`plan-list-element-link plan-list-element-link-${producto.class}`"
          >
            <span>
              Plan Actual
            </span>
          </a>
          <a
            v-else-if="orderProductoActual > producto.order"
            :class="`plan-list-element-link plan-list-element-link-${producto.class}`"
            @click="modalNoDisponible()"
          >
            <span>
              Inhabilitado
            </span>
          </a>

          <!-- Dejo inhabilitado el cambio para ARS en clientes que compraron inicialmente en otra divisa (EUR, USD) -->
          <a
            v-else-if="inhabilitarToArs"
            :class="`plan-list-element-link plan-list-element-link-${producto.class}`"
          >
            <span>
              Inhabilitado
            </span>
          </a>
          <a
            v-else
            :class="`plan-list-element-link plan-list-element-link-${producto.class}`"
            @click="modalPaymentMethod({
              cliente: venta.cliente,
              divisa: divisa,
              gateways: producto.productoGestion
                ? producto.productoGestion.pasarelas
                : '',
              pasarela: '',
              plan: producto.productoGestion
                ? frecuencySelected === 'mensual'
                  ? producto.planMensual
                  : producto.planAnual
                : '',
              producto: producto,
              venta: venta.venta
            })"
          >
            <span>
              Lo Quiero
            </span>
          </a>
        </article>
      </div>
      <div class="m-edition-billing-my-payments-change-plan-help">
        <h3>¿Necesitas ayuda?</h3>
          <p class="font-size-small">Escribenos a hola@vidroop.com o hablemos por Whatsapp en +34 644 928 797</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPaymentsChangePlan',
  data () {
    return {
      academiaId: '',
      cantPV: 1,

      classVidroop: [
        {
          nombre: 'Vidroop Inicia',
          class: 'initial',
          order: 0
        },
        {
          nombre: 'Vidroop Avanza',
          class: 'professional',
          order: 1
        },
        {
          nombre: 'Vidroop Crece',
          class: 'expert',
          order: 2
        },
        {
          nombre: 'Vidroop Vuela',
          class: 'business',
          order: 3
        }
      ],

      divisa: {},

      divisaByGestion: [
        {
          id_divisa: 62,
          nombre: 'Euro',
          simbolo: '€',
          iso_code: 'EUR',
          iso_number: 978,
          decimales: 2,
          activa: true
        },

        {
          id_divisa: 49,
          nombre: 'Dólar estadounidense',
          simbolo: '$',
          iso_code: 'USD',
          iso_number: 840,
          decimales: 2,
          activa: true
        },

        {
          id_divisa: 120,
          nombre: 'Peso Argentino',
          simbolo: '$',
          iso_code: 'ARS',
          iso_number: 32,
          decimales: 2,
          activa: true
        }
      ],

      divisas: [],
      divisaSelected: '',
      frecuencyOriginal: '',
      frecuencySelected: '',
      orderProductoActual: -1,
      planSelected: '',
      productoGestiones: [],
      productosVidroop: [],
      showLoadingState: 0,
      showLoadingStateProduct: 0,
      venta: {}
    }
  },

  computed: {
    inhabilitarToArs () {
      return this.venta.venta.divisa_iso_code
          ? this.divisaSelected === 'ARS' && this.divisaSelected !== this.venta.venta.divisa_iso_code
          : false
    },

    mostrarProductosVidroop () {
      return this.productosVidroop.filter(p => { return p.mostrar }).sort((a, b) => a.order - b.order)
    }
  },

  watch: {
    divisaSelected () {
      this.cantPV = this.cantPV + this.productosVidroop.length
      this.divisa = this.divisas.find(divisa => divisa.iso_code === this.divisaSelected)
      this.productosVidroop.forEach(p => this.readProductoGestiones(p))
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readVenta()
  },

  methods: {
    modalNoDisponible () {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsChangePlanModalDisabled')
    },

    modalPaymentMethod (params) {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalChangePlan', params)
    },

    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.divisaSelected = this.venta.venta.divisa_iso_code
            ? this.venta.venta.divisa_iso_code
            : 'EUR'
          this.divisa = this.divisas.find(divisa => divisa.iso_code === this.divisaSelected)
          this.showLoadingState++
          this.readProductosVidroop()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    configVidroop (productoVidroop) {
      var configVidroop = this.classVidroop.find(config => config.nombre === productoVidroop.nombre)
      if (configVidroop) {
        productoVidroop.mostrar = true
        productoVidroop.class = configVidroop.class
        productoVidroop.order = configVidroop.order
        if (configVidroop.nombre === this.venta.venta.concepto_venta) {
          this.orderProductoActual = configVidroop.order
        }
        if (productoVidroop.tipo_universidad === 0) {
          productoVidroop.universidad = 'Mini'
        } else {
          productoVidroop.universidad = 'Profesional'
        }
        if (productoVidroop.pago) {
          productoVidroop.divisa = this.divisa
          var productoGestion = this.productoGestiones.find(gestion => gestion.divisa.id_divisa === this.divisa.id_divisa)
          if (productoGestion) {
            productoVidroop.productoGestion = Object.assign({}, productoGestion)
            let planesM = productoGestion.planes.find(plan => plan.pago.frecuencia === 3)
            let planesA = productoGestion.planes.find(plan => plan.pago.frecuencia === 4)
            if ((planesM || planesA) && productoGestion.activa) {
              Object.assign(productoVidroop, { planMensual: planesM })
              Object.assign(productoVidroop, { planAnual: planesA })
            } else {
              productoVidroop.mostrar = false
            }
          } else {
            productoVidroop.mostrar = false
          }
        } else {
          productoVidroop.divisa = this.divisa
        }
      }
    },

    readProductoGestiones (productoVidroop) {
      this.$services.read('producto', 'readProductoGestiones', {}, [productoVidroop.id])
        .then(response => {
          this.productoGestiones = response.data
          this.configVidroop(productoVidroop)
          this.showLoadingStateProduct++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingStateProduct++
        })
    },

    readProductosVidroop () {
      this.$services.read('producto', 'readProductosVidroop')
        .then(response => {
          this.productosVidroop = response.data
          this.divisa = this.divisas.find(d => d.iso_code === this.divisaSelected)
          this.cantPV = this.cantPV + (this.productosVidroop.length - 1)
          this.productosVidroop.length
            ? this.productosVidroop.forEach(p => this.readProductoGestiones(p))
            : this.showLoadingStateProduct++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingStateProduct++
        })
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          this.venta = response.data
          /*
           | Con licencias de Droops en la venta el plan es personalizado y no se cambia desde
           | aca: se avisa y se vuelve al plan suscrito. Va en esta pantalla y no solo en el boton
           | que la abre porque tambien se llega por URL, por el header y por el modal de upgrade.
           */
          if (Array.isArray(this.venta.satelites) && this.venta.satelites.length) {
            this.$modal.showModal('MoleculeEditionBillingMyPaymentsChangePlanModalCustomized')
            this.$router.replace(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${this.$t('mEditionMenu.billing.myPayments.children.subscribedPlan.subedition')}`)
            return
          }
          this.readDivisas()
          this.frecuencyOriginal = this.venta.suscripcion
            ? this.venta.suscripcion.pago_frecuencia
            : this.venta.venta.pago_frecuencia
          this.frecuencyOriginal === 4
            ? this.frecuencyOriginal = 'anual'
            : this.frecuencyOriginal = 'mensual'
          this.frecuencySelected = this.frecuencyOriginal
        })
        .catch(error => {
          console.log(error)
          this.showLoadingStateProduct++
        })
    }
  }
}
</script>
